<template>
    <div>
        <eqt-table
           :icon="icon"
           :color="color"
           :header-color="headerColor"
           :hide-search="hideSearch"
           :hide-pagination="hidePagination"
           :hide-show-btn="hideShowBtn"
           :hide-edit-btn="hideEditBtn"
           @refresh="refresh"
           :total="total"
           :loading="loading"
           :title="computedTitle"
           :items="items"
           hide-actions
           :headers="computedHeaders">
                <template slot="filters">
                    <v-flex lg3>
                        <v-autocomplete
                                :items="sectors"
                                v-model="search.sector"
                                :error-messages="errors.first('sector')"
                                :label="$t('Pages.Sectors.title_singular')"
                                name="sector"
                                color="indigo"
                                clearable
                                multiple
                                autocomplete
                                item-text="name"
                                item-value="id"
                        ></v-autocomplete>
                    </v-flex>
                    <v-flex lg3>
                        <v-autocomplete
                                :items="workplaces"
                                v-model="search.workplace"
                                :error-messages="errors.first('workplace')"
                                :label="$t('Pages.Workplaces.title_singular')"
                                name="workplace"
                                color="indigo"
                                clearable
                                multiple
                                autocomplete
                                item-text="name"
                                item-value="id"
                        ></v-autocomplete>
                    </v-flex>
                    <v-flex lg3>
                        <v-tooltip top>
                            <v-btn slot="activator" absolute right small fab dark color="indigo dark1" @click="refresh(null, 1)">
                                <v-icon dark>mdi-download</v-icon>
                            </v-btn>
                            <span>{{$t('Core.Fields.download')}}</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex lg3>
                        <v-select
                                :items="yesNo"
                                v-model="search.agency"
                                :error-messages="errors.first('yesNo')"
                                :label="$t('Pages.Users.model.agency')"
                                name="yesNo"
                                color="indigo"
                                clearable
                                item-text="name"
                                item-value="key"
                        ></v-select>
                    </v-flex>
                    <v-flex lg3>
                        <v-dialog
                                ref="dialog"
                                v-model="modal"
                                :return-value.sync="search.start"
                                persistent
                                lazy
                                full-width
                                width="290px"
                        >
                            <v-text-field
                                    clearable
                                    slot="activator"
                                    v-model="computedStart"
                                    :label="$t('Pages.Vacations.model.start')"
                                    prepend-icon="event"
                                    readonly
                                    color="indigo"
                                    :error-messages="errors.first('start')"
                                    name="start"
                            ></v-text-field>
                            <v-date-picker locale="sr-Latn-RS" first-day-of-week="1" color="indigo" v-model="search.start" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat @click="modal = false">{{$t('Core.Fields.cancel')}}</v-btn>
                                <v-btn flat color="indigo" @click="$refs.dialog.save(search.start)">{{$t('Core.Fields.ok')}}</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-flex lg3>
                        <v-dialog
                                ref="dialogEnd"
                                v-model="modalEnd"
                                :return-value.sync="search.end"
                                persistent
                                lazy
                                full-width
                                width="290px"
                        >
                            <v-text-field
                                    clearable
                                    slot="activator"
                                    v-model="computedEnd"
                                    :label="$t('Pages.Vacations.model.end')"
                                    prepend-icon="event"
                                    readonly
                                    color="indigo"
                                    :error-messages="errors.first('end')"
                                    name="end"
                            ></v-text-field>
                            <v-date-picker  locale="sr-Latn-RS" :min="search.start" first-day-of-week="1" color="indigo" v-model="search.end" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat @click="modalEnd = false">{{$t('Core.Fields.cancel')}}</v-btn>
                                <v-btn flat color="indigo" @click="$refs.dialogEnd.save(search.end)">{{$t('Core.Fields.ok')}}</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                </template>
                <template slot="items" slot-scope="{ item }">
                    <td>{{ item.profile.name}}</td>
                    <td>{{ item.sectors && item.sectors.length > 0 && item.sectors[0].workplace && item.sectors[0].workplace.name}}</td>
                    <td>{{ item.sectors && item.sectors.length > 0 && item.sectors[0].name}}</td>
                    <td class="text-xs-center">{{item.totalOvertimeHours ? item.totalOvertimeHours.value : $t('Common.not_assigned')}}</td>
                    <td class="text-xs-center">{{ item.profile.is_agency ? $t('Common.yes') :  $t('Common.no')}}</td>
                    <slot name="items" :item="item"></slot>
                </template>
        </eqt-table>

    </div>
</template>

<script>
    import EqtTable from '../../../components/core/Table'
    import i18n from '@/i18n'
    export default {
        name: "reports-table",
        components: {EqtTable},
        props: {
            items: {
              type: Array,
              required: true
            },
            total: {
                type: Number,
                default: 0,
            },
            loading: {
                type: Boolean,
                default: false
            },
            hideActions: {
                type: Boolean,
                default: false
            },
            icon: {
                type: String,
                default: ''
            },
            color: {
                type: String,
                default: 'tertiary'
            },
            headerColor: {
                type: String,
                default: 'text-primary text--darken-3'
            },
            title: {
                type: String,
                default: null,
            },
            hidePagination: {
                type: Boolean,
                default: false
            },
            hideSearch: {
                type: Boolean,
                default: false
            },
            hideShowBtn: {
                type: Boolean,
                default: false
            },
            hideEditBtn: {
                type: Boolean,
                default: false
            },
            sortable: {
                type: Boolean,
                default: true
            },
            appendHeaders: {
                type: Array,
                default: () => []
            },
        },
        data() {
            let data = {
                headers: [
                    {
                        sortable: this.sortable && false,
                        text: i18n.t('Pages.Users.title_singular'),
                        value: 'name'
                    },
                    {
                        sortable: this.sortable && false,
                        text: i18n.t('Pages.Workplaces.title_singular'),
                        value: 'name'
                    },
                    {
                        sortable: this.sortable && false,
                        text: i18n.t('Pages.Sectors.title_singular'),
                        value: 'name'
                    },
                    {
                        sortable: this.sortable && true,
                        text: i18n.t('Pages.ScheduledOvertimes.model.hours'),
                        value: 'hours',
                        align: 'center'
                    },
                    {
                        sortable: this.sortable && false,
                        text: i18n.t('Pages.Users.model.agency'),
                        value: 'name',
                        align: 'center'
                    },

                ],
                modal: false,
                modalEnd: false,
                data: {},
                search: {sector: null, start: null, end: null, agency: null},
                sectors: [],
                workplaces: [],
                selectedId: null,
                yesNo: [],
            };

            return data;
        },
        computed:{
            computedHeaders(){
                return this.headers.concat(this.appendHeaders);
            },
            computedTitle(){
                return this.title ? this.title : this.$t('Pages.Reports.overtime_title');
            },
            computedStart: {
                get: function () {
                    return this.getLocaleDateFormat(this.search.start);
                },
                set: function(val){
                    this.search.start = val;
                }
            },
            computedEnd: {
                get: function () {
                    return this.getLocaleDateFormat(this.search.end);
                },
                set: function(val){
                    this.search.end = val;
                }
            },
        },
        created(){
            this.getSectors();
            this.getWorkplaces();

            this.yesNo = [
                {
                    key: 1,
                    name: this.$t('Common.yes')
                },
                {
                    key: 0,
                    name: this.$t('Common.no')
                },
            ];
        },
        methods: {
            refresh(data, shouldExport = 0){

                if(data) {
                    this.data = data;
                }
                else{
                    data = this.data;
                }

                data.export = shouldExport;
                data.sector = this.search.sector;
                data.workplace = this.search.workplace;
                data.start = this.search.start;
                data.end = this.search.end;
                data.agency = this.search.agency;

                this.$emit('refresh', data);
            },

            getSectors(){
                this.repositories.sector.all().then((response) => {
                    this.sectors = response.data.data;
                });
            },

            getWorkplaces(){
                this.repositories.workplace.all().then((response) => {
                    this.workplaces = response.data.data;
                });
            },
        },
        watch: {
            'search.sector': function(){
                this.refresh();
            },
            'search.workplace': function(){
                this.refresh();
            },
            'search.start': function(){
                this.refresh();
            },
            'search.end': function(){
                this.refresh();
            },
            'search.agency': function(){
                this.refresh();
            },
        }
    }
</script>

<style scoped>

</style>
